export default "__VITE_ASSET__DPxNtVxh__"